import axios from "axios";

//axios.defaults.baseURL = "http://localhost:8080/api/v1";
axios.defaults.baseURL = "https://www.askuni.com/api/v1";
//axios.defaults.baseURL = "https://askuni.herokuapp.com/api/v1";
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

export const Store = {
  access_token: localStorage.getItem("access_token") || null,
  perms: [],
  user_id: parseInt(localStorage.getItem("user_id")) || null,
  first_name: localStorage.getItem("first_name") || "",
  last_name: localStorage.getItem("last_name") || "",
  user_picture: null,
  role: parseInt(localStorage.getItem("role")) || null,
  role_name: localStorage.getItem("role_name") || "",
  email: localStorage.getItem("email") || "",
  countries: null,
  cities: null,
  seasons: null,
  cacheGeneralInformationForChart: null,
  languages: {
    Turkish: 1,
    English: 2,
    "%30 English %70 Turkish": 3,
    "%50 English %50 Turkish": 4,
    Arabic: 5,
    Russian: 6,
    Spanish: 7,
    French: 8,
    German: 9,
    "%30 Arabic %70 Turkish": 10,
    "%30 German %70 Turkish": 11
  },
  role_slug: {
    1: "admin",
    2: "student",
    3: "agency",
    4: "university",
    5: "dorm"
  },
  refund_policy: {
    1: "No Refund",
    2: "%25 Refund",
    3: "%50 Refund",
    4: "%75 Refund",
    5: "Full Refund"
  },
  format_date(date) {
    if (typeof date === "object") {
      return date
        .toLocaleDateString("ko-KR")
        .replaceAll(". ", "-")
        .replaceAll(".", "");
    } else {
      return date;
    }
  },
  loggedIn() {
    return this.access_token !== null;
  },
  login(credential) {
    return new Promise((resolve, reject) => {
      axios
        .post("/login/", {
          email: credential.email,
          password: credential.password
        })
        .then(response => {
          const token = response.data.token;
          this.access_token = token;
          this.user_id = response.data.id;
          this.first_name = response.data.first_name;
          this.last_name = response.data.last_name;
          this.user_picture = response.data.picture;
          this.role = response.data.role;
          this.role_name = response.data.role_name;
          this.email = response.data.email;
          localStorage.setItem("access_token", token);
          localStorage.setItem("user_id", this.user_id);
          localStorage.setItem("first_name", this.first_name);
          localStorage.setItem("last_name", this.last_name);
          localStorage.setItem("role", this.role);
          localStorage.setItem("role_name", this.role_name);
          localStorage.setItem("email", this.email);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  logoutBase() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("first_name");
    localStorage.removeItem("last_name");
    localStorage.removeItem("role");
    localStorage.removeItem("role_name");
    localStorage.removeItem("email");
    delete axios.defaults.headers.common["Authorization"];
    this.access_token = null;
    this.user_id = null;
    this.first_name = null;
    this.last_name = null;
    this.user_picture = null;
    this.role = null;
    this.role_name = null;
    this.email = null;
    this.perms = [];
  },
  logout() {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .post("/logout/")
        .then(response => {
          this.logoutBase();
          resolve(response);
        })
        .catch(error => {
          this.logoutBase();
          reject(error);
        });
    });
  },
  getNotifications() {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/notification/?limit=10")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getNotificationCount() {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/notification/count/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  register(credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post("/signup/", {
          first_name: credentials.first_name,
          last_name: credentials.last_name,
          email: credentials.email,
          role: credentials.role,
          password: credentials.password
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  me() {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/me")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateMe(data) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .put("/me", {
          first_name: data.first_name,
          last_name: data.last_name,
          gender: data.gender,
          mobile_phone: data.mobile_phone,
          title: data.title,
          country: parseInt(data.country)
        })
        .then(response => {
          this.first_name = response.data.first_name;
          this.last_name = response.data.last_name;
          localStorage.setItem("first_name", this.first_name);
          localStorage.setItem("last_name", this.last_name);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updatePass(data) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .put("/update_pass", {
          password: data.password,
          new_password: data.new_password,
          re_new_password: data.re_new_password
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateAvatar(image) {
    let formData = new FormData();
    formData.append("picture", image, image.name);
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .patch("/me", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => {
          this.user_picture = response.data.picture;
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getCountries(params, non_cache) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      if (this.countries && !non_cache) {
        return resolve(this.countries);
      }
      axios
        .get("/country/", { params: params })
        .then(response => {
          if (!non_cache) {
            this.countries = response;
          }
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getCountry(country_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/country/" + country_id + "/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createCountry(data) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "/country/",
        data: data
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateCountry(data, country_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: "PUT",
        url: "/country/" + country_id + "/",
        data: data
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getCities(params, non_cache) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      if (this.cities && !non_cache) {
        return resolve(this.cities);
      }
      axios
        .get("/city/", { params: params })
        .then(response => {
          if (!non_cache) {
            this.cities = response;
          }
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getCity(city_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/city/" + city_id + "/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createCity(data) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "/city/",
        data: data
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateCity(data, city_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: "PUT",
        url: "/city/" + city_id + "/",
        data: data
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getPlaces(params) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/place/", { params: params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getTransportations(params) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/transportation/", { params: params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getUsers(role, params) {
    let url = "/users/" + this.role_slug[role] + "/";
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get(url, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getUser(role, user_id) {
    let url = "/users/" + this.role_slug[role] + "/";
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get(url + user_id + "/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getUserOtherFiles(user_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/users/student/" + user_id + "/other_files/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getUserPermissions(role, user_id) {
    let url =
      "/users/" + this.role_slug[role] + "/" + user_id + "/permissions/";
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addUserPermissions(role, user_id, codename) {
    let url =
      "/users/" + this.role_slug[role] + "/" + user_id + "/add_permission/";
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .post(url, { codename: codename })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeUserPermissions(role, user_id, codename) {
    let url =
      "/users/" + this.role_slug[role] + "/" + user_id + "/remove_permission/";
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .post(url, { codename: codename })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  upsertBasicUser(method, user_id, data, role) {
    let formData = new FormData();
    for (const item in data) {
      if (item !== "picture") {
        formData.append(item, data[item]);
      }
    }
    if (data.picture) {
      formData.append("picture", data.picture, data.picture.name);
    }
    if (user_id) {
      var url = "/users/" + this.role_slug[role] + "/" + user_id + "/";
    } else {
      var url = "/users/" + this.role_slug[role] + "/";
    }
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: method,
        url: url,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addUserInformation(method, user_id, data) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: method,
        url: "/users/student/" + user_id + "/update_user_information/",
        data: data
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addUserFile(user_id, file, fieldName) {
    let formData = new FormData();
    formData.append(fieldName, file, file.name);
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .put("/users/student/" + user_id + "/add_user_file/", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addUserOtherFile(user_id, file, type) {
    let formData = new FormData();
    formData.append("type", type);
    formData.append("file", file, file.name);
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .post("/users/student/" + user_id + "/add_other_files/", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteUserOtherFile(user_id, file_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .delete(
          "/users/student/" +
            user_id +
            "/delete_other_files/?file_id=" +
            file_id
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getUniversities(params, basic) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    let url = "/university/";
    if (basic) {
      url = "/university/basic/";
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url, { params: params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getUniversity(university_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/university/" + university_id + "/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  upsertUniversity(data, university_id) {
    let formData = new FormData();
    for (const item in data) {
      if (item !== "picture") {
        formData.append(item, data[item]);
      }
    }
    if (data.picture) {
      formData.append("picture", data.picture, data.picture.name);
    }
    var url = "/university/";
    var method = "POST";
    if (university_id) {
      url = "/university/" + university_id + "/";
      method = "PATCH";
    }
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: method,
        url: url,
        data: formData,
        header: { "Content-Type": "multipart/form-data" }
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getPrograms(params, basic, detail) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    let url = "/university/programs/";
    if (basic) {
      url = "/university/programs/basic/";
      if (detail) {
        url = "/university/programs/basic-detail/";
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url, { params: params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getProgram(program_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/university/programs/" + program_id + "/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createProgram(data) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "/university/programs/",
        data: data
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateProgram(data, program_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: "PUT",
        url: "/university/programs/" + program_id + "/",
        data: data
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updatePrograms(data, params) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "/university/programs/update-programs/",
        data: data,
        params: params
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getApplications(params) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/application/", { params: params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getApplication(application_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/application/" + application_id + "/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getApplicationLogs(application_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/application/" + application_id + "/logs/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getApplicationChats(application_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/application/" + application_id + "/chats/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getApplicationFiles(application_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/application/" + application_id + "/files/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addApplicationChat(application_id, data) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .post("/application/" + application_id + "/add_chat/", data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  approveApplication(application_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .post("/application/" + application_id + "/approve/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  sendApplication(application_id, data) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .post("/application/" + application_id + "/send/", data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createApplication(data) {
    let formData = new FormData();
    for (const item in data) {
      if (item !== "agreement") {
        formData.append(item, data[item]);
      }
    }
    if (data.agreement) {
      formData.append("agreement", data.agreement, data.agreement.name);
    }
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "/application/",
        data: formData,
        header: { "Content-Type": "multipart/form-data" }
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateApplication(data, application_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .put("/application/" + application_id + "/", data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteApplication(application_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .delete("/application/" + application_id + "/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  nextStatus(data, application_id) {
    let formData = new FormData();
    for (const item in data) {
      if (item !== "file") {
        formData.append(item, data[item]);
      }
    }
    if (data.file) {
      formData.append("file", data.file, data.file.name);
    }
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "/application/" + application_id + "/next_status/",
        data: formData,
        header: { "Content-Type": "multipart/form-data" }
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  assignAuthorizedUserToApplication(application_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/application/" + application_id + "/assign_authorized_user/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getDorms() {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/dorms/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getDorm(dorm_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/dorms/" + dorm_id + "/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createDorm(data) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .post("/dorms/", data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateDorm(data, dorm_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .put("/dorms/" + dorm_id + "/", data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAgencies(params) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/agencies/", { params: params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAgency(agency_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/agencies/" + agency_id + "/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createAgency(data) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .post("/agencies/", data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateAgency(data, agency_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .put("/agencies/" + agency_id + "/", data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getCommissions(params) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/commissions/", { params: params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getCommission(commission_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/commissions/" + commission_id + "/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createCommission(data) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .post("/commissions/", data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createBulkCommission(data) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .post("/commissions/bulk-create/", data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateCommission(data, commission_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .put("/commissions/" + commission_id + "/", data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getSeason(season_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/season/" + season_id + "/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getSeasons(params, cached) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      if (this.seasons && cached) {
        return resolve(this.seasons);
      }
      axios
        .get("/season/", { params: params })
        .then(response => {
          if (cached) {
            this.seasons = response;
          }
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createSeason(data) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .post("/season/", data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateSeason(data, season_id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .put("/season/" + season_id + "/", data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getGeneralInformation() {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/general_information/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getGeneralInformationForChart() {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      if (this.cacheGeneralInformationForChart) {
        return resolve(this.cacheGeneralInformationForChart);
      }
      axios
        .get("/general_information_for_chart/")
        .then(response => {
          this.cacheGeneralInformationForChart = response;
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getCandidates(params) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/candidate-form/", { params: params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getCandidate(id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/candidate-form/" + id + "/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createCandidate(data) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "/candidate-form/",
        data: data
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateCandidate(data, id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: "PUT",
        url: "/candidate-form/" + id + "/",
        data: data
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateCandidateStatus(data, id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "/candidate-form/" + id + "/status/",
        data: data
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteCandidate(data, id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: "DELETE",
        url: "/candidate-form/" + id + "/",
        data: data
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getUniversityAnnouncements(params) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/university/announcements/", { params: params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getUniversityAnnouncement(id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/university/announcements/" + id + "/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createUniversityAnnouncement(data) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "/university/announcements/",
        data: data
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateUniversityAnnouncement(data, id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: "PUT",
        url: "/university/announcements/" + id + "/",
        data: data
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteUniversityAnnouncement(id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: "DELETE",
        url: "/university/announcements/" + id + "/"
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getArticles(params) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/article/", { params: params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getArticle(id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios
        .get("/article/" + id + "/")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createArticle(data) {
    let formData = new FormData();
    for (const item in data) {
      if (item !== "image") {
        formData.append(item, data[item]);
      }
    }
    if (data.image) {
      formData.append("image", data.image, data.image.name);
    }
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "/article/",
        data: formData,
        header: { "Content-Type": "multipart/form-data" }
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateArticle(data, id) {
    let formData = new FormData();
    for (const item in data) {
      if (item !== "image") {
        formData.append(item, data[item]);
      }
    }
    if (data.image) {
      formData.append("image", data.image, data.image.name);
    }
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: "PATCH",
        url: "/article/" + id + "/",
        data: formData,
        header: { "Content-Type": "multipart/form-data" }
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteArticle(id) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + this.access_token;
    return new Promise((resolve, reject) => {
      axios({
        method: "DELETE",
        url: "/article/" + id + "/"
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

axios.interceptors.response.use(
  config => {
    // perform a task before the request is sent
    return config;
  },
  error => {
    // handle the error
    if (error.response.status === 401) {
      Store.logoutBase();
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

const DefaultStore = {
  install(Vue, options) {
    Vue.mixin({
      data() {
        return {
          default_store: Store
        };
      }
    });

    Object.defineProperty(Vue.prototype, "$store", {
      get() {
        return this.$root.default_store;
      }
    });
  }
};

export default DefaultStore;
